import * as React from "react";
import { useState, useMemo, useCallback } from "react";
import classnames from "classnames";
import { useFormContext } from "../../Form/Form/Form.js";
import { FormControl } from "../../FormControl/FormControl/FormControl.js";
import Select from "../../Select/Select/Select.js";
import { Toggletip } from "../../Toggletip/Toggletip/Toggletip.js";
const FormSelect = ({
  id,
  name,
  label,
  options,
  errorMessage,
  className,
  tooltipLabel,
  placeholder,
  onChange,
  initialState,
  disabled = false,
  required = false,
  hideAsteriskSign = false,
  optionalText
}) => {
  const [value, setValue] = useState(initialState && initialState.value || "");
  const [isTouched, setIsTouched] = useState(initialState && initialState.isTouched || false);
  const isValid = useMemo(
    () => FormControl.validate([], [], required, value, errorMessage).isValid,
    [errorMessage, required, value]
  );
  const readonly = initialState && initialState.readonly;
  const selectValue = Object.entries(options).find(([_, opt]) => opt.value === value)?.[1]?.label;
  React.useEffect(() => {
    onChange?.({
      value,
      name,
      errorMessage,
      isValid,
      isTouched,
      ...readonly === void 0 ? {} : { readonly }
    });
  }, [onChange, value, name, isValid, isTouched, errorMessage, readonly]);
  React.useEffect(() => {
    setValue(initialState?.value || "");
    setIsTouched(initialState?.isTouched || false);
  }, [initialState?.value, initialState?.isTouched]);
  const handleChange = useCallback(
    (option) => {
      setValue(option.value);
      setIsTouched(true);
    },
    [required]
  );
  const classes = classnames(`${name}-select__input`, {
    _is_valid: isValid && isTouched && !readonly,
    _is_invalid: !isValid && isTouched && !readonly
  });
  return /* @__PURE__ */ React.createElement("label", { className: classnames("form-control", `${name}-select`, className) }, label && /* @__PURE__ */ React.createElement("div", { className: "form-control__label" }, label, required && !hideAsteriskSign && /* @__PURE__ */ React.createElement("span", { className: "form-control__asterisk" }, "*"), !required && optionalText && /* @__PURE__ */ React.createElement("small", { className: "form-control__optional-tag" }, optionalText), tooltipLabel && /* @__PURE__ */ React.createElement(Toggletip, { message: tooltipLabel })), /* @__PURE__ */ React.createElement("div", { className: "form-control__wrapper" }, /* @__PURE__ */ React.createElement(
    Select,
    {
      className: classes,
      id,
      name,
      placeholder,
      options,
      initialState: { value: selectValue || "", isTouched, isValid, errorMessage },
      onChange: handleChange,
      disabled: disabled || readonly,
      "aria-invalid": !isValid,
      "aria-describedby": `${name}-select-error`
    }
  )), !isValid && isTouched && /* @__PURE__ */ React.createElement("span", { id: `${name}-select-error`, className: "form-control__error" }, errorMessage));
};
const ConnectedFormSelect = (props) => {
  const { getInitialState, onChange } = useFormContext();
  const handleChange = React.useCallback(
    (formControlState) => {
      onChange?.(formControlState);
    },
    [onChange]
  );
  return /* @__PURE__ */ React.createElement(
    FormSelect,
    {
      ...props,
      onChange: handleChange,
      initialState: getInitialState?.(props.name) || props.initialState
    }
  );
};
export {
  ConnectedFormSelect,
  FormSelect
};
//# sourceMappingURL=FormSelect.js.map
